module.exports = __webpack_public_path__ + "static/media/ICO.481fe04c.svg";